import { Button, Header } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { devLog } from '@methods/devLog'
import { IkanoIDBackIcon } from './icons/IkanoIDBackIcon'
import { IkanoIDFrontIcon } from './icons/IkanoIDFrontIcon'

export const AddressVerificationTwoSidedIkanoPage = observer(() => {
  const store = useContext(StoreContext)
  const { isMobile } = store.AppState
  const { context } = store.ScenarioState
  const { addressVerificationTwoSidedIkano: trans } = store.TranslationsState.translations

  const handleProceed = async () => {
    try {
      store.ScenarioState.setCurrentPage(1)
    } catch (e) {
      devLog(e)
    }
  }

  return (
    <div className="page-container">
      <Header>{!context?.isRetryAttempt ? trans.header : trans.headerRetry}</Header>
      <div className="generic__paragraph">
        {!context?.isRetryAttempt ? trans.addressDescription : trans.addressDescriptionRetry}
      </div>

      <div className="generic__paragraph-with-border">
        {context?.expectedAddress?.street}, {context?.expectedAddress?.postalCode}{' '}
        {context?.expectedAddress?.city}
      </div>

      <div className="generic__paragraph">
        {!context?.isRetryAttempt ? trans.descriptionPartOne : trans.descriptionPartOneRetry}
      </div>

      <div className="generic__paragraph">
        {!context?.isRetryAttempt ? trans.descriptionPartTwo : trans.descriptionPartTwoRetry}
      </div>

      <div className="horizontal-icon-container">
        <IkanoIDFrontIcon />
        <IkanoIDBackIcon />
      </div>

      <div className="layout__content-container-bottom-fixed layout__content-container-bottom-fixed--gap-16">
        {!isMobile ? <div className="layout__content-container-bottom-left" /> : <></>}
        <Button id="btn-proceed" onClick={handleProceed} className="ikano__proceed-btn">
          <span className="generic__button-text">{trans.proceed}</span>
        </Button>
      </div>
      <div className="layout__mobile-spacer-for-content-container-bottom-fixed" />
    </div>
  )
})
